require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.is-iterable');


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-runtime/~/core-js/library/fn/is-iterable.js
 ** module id = 405
 ** module chunks = 1 2 3 10 11 13 17 19 20 21 22 26 33
 **/